import { baseApiUrl, fetcher, handleError, ServerErrorResponse } from 'data_sources/constants';

export default function useManageGroupRole() {
  const addRole = async (
    organizationId: string,
    groupId: string,
    roleId: string,
    callback?: (guid: string) => void,
    onError?: (errors: ServerErrorResponse) => void
  ) => {
    const url = `${baseApiUrl()}/lexid/user-group/v1/organizations/${organizationId}/groups/${groupId}/roles/${roleId}`;
    await fetcher({
      method: 'post',
      url,
      body: {},
    })
      .then((data) => {
        if (callback) callback(data.id);
      })
      .catch((err) => {
        if (onError) handleError(err, { onError });
      });
  };

  const removeRole = async (
    organizationId: string,
    groupId: string,
    roleId: string,
    callback?: (guid: string) => void,
    onError?: (errors: ServerErrorResponse) => void
  ) => {
    const url = `${baseApiUrl()}/lexid/user-group/v1/organizations/${organizationId}/groups/${groupId}/roles/${roleId}`;
    await fetcher({
      method: 'delete',
      url,
      body: {},
    })
      .then(() => {
        if (callback) callback(roleId);
      })
      .catch((err) => {
        if (onError) handleError(err, { onError });
      });
  };

  return {
    addRole,
    removeRole,
  };
}
